<template>
    <div class="entities-selector">
        <div class="title-icons">
            <h1>entities</h1>
            <div style="display: flex;">
                <search-filter @new-value="searchFilter = $event"></search-filter>
            </div>
        </div>
        <div class="entity-container">
            <entity-view
                v-for="entity in entities"
                :key="entity.uid"
                :entity="entity"
            ></entity-view>
        </div>
    </div>
</template>

<script>
import EntityView from './entity.vue';

import { SearchFilter } from 'gcmcn-common';
export default {

    components: {
        EntityView,
        SearchFilter,
    },

    props: {

    },

    data (){
        return {
            searchFilter: '',
        };
    },

    computed: {
        entities (){
            if(this.searchFilter === ''){
                return this.$store.getters.entities;
            }
            return this.$store.getters.entities.filter((entity) => {
                return entity.display_name.toLowerCase().includes(this.searchFilter.toLowerCase());
            });
        },
    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
.entities-selector{
    .title-icons{
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        .entities-icon{
            margin-left: 15px;
            background-color: #222;
            padding: 5px !important;
            border: none;
            color: #fff;
        }
        h1 {
            font-size: 30px;
        }
    }
    .entity-container{
        margin-top: 10px;
        height: calc(100vh - 110px);
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/entities-selector.vue